// Кто сейчас в мире — данные для панели присутствия.
//
// Идея: ИИ-жители (Mia, Зодчий) не «персонажи где-то в мире», а часть
// интерфейса: они всегда наверху списка, с ними можно заговорить в один клик.
// Живые игроки идут следом, по близости — с кем рядом стоишь, тот и первый.

// Имена наших ИИ-жителей и что они умеют.
export const AI_RESIDENTS = {
  mia: { match: /^mia$/i, label: 'Mia', role: 'спутница мира', greeting: 'Mia, привет!' },
  architect: { match: /^зодчий$/i, label: 'Зодчий', role: 'строит по просьбе', greeting: '!build help' },
}

export function residentOf(name) {
  for (const [id, resident] of Object.entries(AI_RESIDENTS)) {
    if (resident.match.test(String(name || '').trim())) return { id, ...resident }
  }
  return null
}

// Список для панели: ИИ наверху, потом остальные по расстоянию, сам игрок
// помечен и не мешается в сортировке.
export function buildPresenceList(players, { localId } = {}) {
  const rows = []
  for (const player of players || []) {
    if (!player) continue
    const userId = String(player.userId || player.id || '')
    if (!userId) continue
    rows.push({
      id: userId,
      userId,
      name: player.name || 'Гость',
      isSelf: userId === String(localId || ''),
      online: player.online !== false,
    })
  }
  return rows.sort((left, right) => {
    if (left.isSelf !== right.isSelf) return left.isSelf ? 1 : -1
    return left.name.localeCompare(right.name) || left.userId.localeCompare(right.userId)
  })
}

// Действия строки списка -> аргументы команды мира.
export function presenceActions(row, capabilities = {}) {
  if (!row || row.isSelf || !row.online) return []
  const actions = []
  if (capabilities.directChat === true) actions.push({ id: 'direct', label: 'Написать', userId: row.userId })
  if (capabilities.party === true) actions.push({ id: 'party', label: 'Группа', userId: row.userId })
  return actions
}
